import * as generalHelper from "../../../helpers/generalHelper";
import * as menuConstants from "../../../constants/menuConstants";
import * as methods from "../../../constants/serverMethods";
import * as navigationActions from "../../../actions/navigationActions";
import * as objectTypes from "../../../constants/objectTypes";
import * as optionHelper from "../../../helpers/optionHelper";
import * as optionsConstants from "../../../constants/optionsConstants";
import * as propertyConstants from "../../../constants/propertyConstants";
import * as settingsActions from "../../../actions/optionActions";
import * as spectroActions from "../../../actions/colorActions";
import * as tableHelper from "../../../helpers/tableHelper";
import * as universalObjectActions from "../../../actions/universalObjectActions";

import { AppState } from "../../../reducers";
import { Color } from "../../../types/color";
import { ColorData } from "../../../types/colorData";
import { Dispatch } from "redux";
import { Fandeck } from "../../../types/fandeck";
import { MenuItem } from "../../../types/menu";
import { Product } from "../../../types/product";
import { ServerRequest } from "../../../types/serverRequest";
import { Unit } from "../../../types/unit";
import { ZoneColorScene } from "../../../components/scenes/zone/ZoneColorScene";

import { connect } from "react-redux";

export type PropsType = Readonly<{
    menuScene: MenuItem | null;
    activeBookmark: string | null;
    fandeckList: Array<Fandeck>;
    fandeckActiveList: Array<Fandeck>;
    fandeckLoading: boolean;
    productList: Array<Product>;
    productActiveList: Array<Product>;
    colorTableConstant: string;
    colorDetailTableConstant: string;
    colorList: Array<Color>;
    colorActiveList: Array<Color>;
    // colorModalActiveList: Array<Color>;
    colorLoading: boolean;
    colorColumnOrder: Array<propertyConstants.Property>;
    colorColumnVisibility: Record<propertyConstants.Property, boolean>;
    colorColumnWidth: Record<propertyConstants.Property, number>;
    colorOffset: number;
    colorPage: number;
    colorRowCount: number;
    colorRowCountCustom: boolean;
    colorSceneTableSize: Record<string, any> | null;
    colorSearch: string | null;
    colorSearchParams: Record<propertyConstants.Property, string>;
    colorShowFilterRow: boolean;
    colorShowGlobalSearch: boolean;
    colorSortingAsc: boolean;
    colorSortingCriterion: propertyConstants.Property | null;
    colorTotalCount: number | null;
    formulasLoading: boolean;
    formulaColorantTableConstant: string;
    formulaColorantColumnOrder: Array<propertyConstants.Property>;
    formulaColorantColumnVisibility: Record<propertyConstants.Property, boolean>;
    formulaColorantColumnWidth: Record<propertyConstants.Property, number>;
    unitList: Array<Unit>;
    activeUnit: Unit | null;
    optionUseTmcNames: boolean | null;
    sceneLayout: string | null;
    sessionUuid: string | null;
    urlRest: string;
}>;

export type DispatchType = Readonly<{
    setActive(objectType: objectTypes.ObjectType, items: Array<any>): any;
    setActiveBookmark(key: string): void;
    setOptions(options: Array<{ key: string; object?: string; value?: any; locked?: boolean }>, save: boolean): any;
    setSearch(objectType: objectTypes.ObjectType, search: string, column?: string): any;
    updateColorData(objectType: objectTypes.ObjectType, colorData: Array<ColorData>, spectroTypeId: any): void;
}>;

const mapStateToProps = (state: AppState): PropsType => ({
    menuScene: generalHelper.getMenuItemByKey(
        state.navigation.menuList,
        menuConstants.MENU_MAIN_PAGE,
        menuConstants.PAGE_ZONE_COLORS
    ),
    activeBookmark: state.navigation.activeBookmark,
    fandeckList: state.fandeck.zoneList,
    fandeckActiveList: state.fandeck.zoneActiveList,
    fandeckLoading: state.server.requests.some(
        (request: ServerRequest) => request.method === methods.METHOD_GET_ALL_ZONE_SIMPLE_FANDECKS
    ),
    productList: state.product.zoneList,
    productActiveList: state.product.zoneActiveList,
    colorTableConstant: menuConstants.TABLE_ZONE_COLORS,
    colorDetailTableConstant: menuConstants.TABLE_ZONE_COLORS_DETAIL,
    colorList: state.color.zoneList,
    colorActiveList: state.color.zoneActiveList,
    // colorModalActiveList: state.color.masterModalActiveList,
    colorLoading: state.server.requests.some(
        (request: ServerRequest) => request.method === methods.METHOD_GET_ALL_ZONE_COLORS_IN_FANDECKS_BY_FANDECK
    ),
    colorColumnOrder: generalHelper.getObjectFromDictionaryByKey(
        state.login.options,
        optionsConstants.OPTION_TABLE_COLUMNS_ORDER,
        menuConstants.TABLE_ZONE_COLORS
    ),
    colorColumnVisibility: generalHelper.getObjectFromDictionaryByKey(
        state.login.options,
        optionsConstants.OPTION_TABLE_COLUMNS_VISIBILITY,
        menuConstants.TABLE_ZONE_COLORS
    ),
    colorColumnWidth: generalHelper.getObjectFromDictionaryByKey(
        state.login.options,
        optionsConstants.OPTION_TABLE_COLUMNS_WIDTH,
        menuConstants.TABLE_ZONE_COLORS
    ),
    colorOffset: state.color.zoneOffset,
    colorPage: state.color.zonePage,
    colorRowCount: generalHelper.getObjectFromDictionaryByKey(
        state.login.options,
        optionsConstants.OPTION_TABLE_ROW_COUNT,
        menuConstants.TABLE_ZONE_COLORS
    ),
    colorRowCountCustom: generalHelper.getObjectFromDictionaryByKey(
        state.login.options,
        optionsConstants.OPTION_TABLE_ROW_COUNT_CUSTOM,
        menuConstants.TABLE_ZONE_COLORS
    ),
    colorSceneTableSize: generalHelper.getObjectFromDictionaryByKey(
        state.login.options,
        optionsConstants.OPTION_SCENE_TABLE_SIZE,
        menuConstants.PAGE_ZONE_COLORS
    ),
    colorSearch: state.color.zoneSearch,
    colorSearchParams: state.color.zoneSearchParams,
    colorShowFilterRow: generalHelper.getObjectFromDictionaryByKey(
        state.login.options,
        optionsConstants.OPTION_SHOW_FILTER_ROW,
        menuConstants.TABLE_ZONE_COLORS
    ),
    colorShowGlobalSearch: generalHelper.getObjectFromDictionaryByKey(
        state.login.options,
        optionsConstants.OPTION_SHOW_GLOBAL_SEARCH,
        menuConstants.TABLE_ZONE_COLORS
    ),
    colorSortingAsc: tableHelper.getSortingObjectValue(
        generalHelper.getObjectFromDictionaryByKey(
            state.login.options,
            optionsConstants.OPTION_TABLE_SORTING,
            menuConstants.TABLE_ZONE_COLORS
        )
    ),
    colorSortingCriterion: tableHelper.getSortingObjectKey(
        generalHelper.getObjectFromDictionaryByKey(
            state.login.options,
            optionsConstants.OPTION_TABLE_SORTING,
            menuConstants.TABLE_ZONE_COLORS
        )
    ),
    colorTotalCount: state.color.zoneCount,
    formulasLoading: state.server.requests.some(
        (request: ServerRequest) => request.method === methods.METHOD_GET_ZONE_MAIN_FORMULAS_FOR_COMBINATION
    ),
    formulaColorantTableConstant: menuConstants.TABLE_ZONE_FORMULA_COLORANTS,
    formulaColorantColumnOrder: generalHelper.getObjectFromDictionaryByKey(
        state.login.options,
        optionsConstants.OPTION_TABLE_COLUMNS_ORDER,
        menuConstants.TABLE_ZONE_FORMULA_COLORANTS
    ),
    formulaColorantColumnVisibility: generalHelper.getObjectFromDictionaryByKey(
        state.login.options,
        optionsConstants.OPTION_TABLE_COLUMNS_VISIBILITY,
        menuConstants.TABLE_ZONE_FORMULA_COLORANTS
    ),
    formulaColorantColumnWidth: generalHelper.getObjectFromDictionaryByKey(
        state.login.options,
        optionsConstants.OPTION_TABLE_COLUMNS_WIDTH,
        menuConstants.TABLE_ZONE_FORMULA_COLORANTS
    ),
    unitList: state.color.unitAllList,
    activeUnit:
        state.color.unitAllList.find(
            (item: Unit) =>
                optionHelper.getValueFromOptionDictionaryByKey(
                    state.login.options,
                    optionsConstants.OPTION_FORMULA_COLORANT_UNIT
                ) === item[propertyConstants.PROPERTY_NAME]
        ) ?? null,
    optionUseTmcNames: optionHelper.getValueFromOptionDictionaryByKey(
        state.login.options,
        optionsConstants.OPTION_USE_TMC_NAMES
    ),
    sceneLayout: generalHelper.getObjectFromDictionaryByKey(
        state.login.options,
        optionsConstants.OPTION_SCENE_LAYOUT,
        menuConstants.PAGE_ZONE_COLORS
    ),
    sessionUuid: state.software.sessionUuid,
    urlRest: state.server.urlRest
});
const mapDispatchToProps = (dispatch: Dispatch): DispatchType => ({
    setActive: (objectType: objectTypes.ObjectType, items: Array<any>): any =>
        dispatch(universalObjectActions.setActiveItems(objectType, items)),
    setActiveBookmark: (key: string): any => dispatch(navigationActions.setActiveBookmark(key)),
    setOptions: (options: Array<{ key: string; object?: string; value?: any; locked?: boolean }>, save: boolean): any =>
        dispatch(settingsActions.setDictionaryOptions(null, options, save)),
    setSearch: (objectType: objectTypes.ObjectType, search: string | null, column?: string): any =>
        dispatch(universalObjectActions.setSearch(objectType, search, column)),
    updateColorData: (objectType: objectTypes.ObjectType, colorData: Array<ColorData>, spectroTypeId: any): any =>
        dispatch(spectroActions.updateColorData(objectType, colorData, spectroTypeId))
});

export const ZoneColorSceneContainer = connect(mapStateToProps, mapDispatchToProps)(ZoneColorScene);
